import { combineReducers } from 'redux'
import { lastSeen } from './lastSeen'
import { localizeReducer } from 'react-localize-redux'
import { mainNavIsVisible } from './mainNavIsVisible'
import { pageOverlayIsVisible } from './pageOverlayIsVisible'

const reducers = combineReducers({
  lastSeen,
  localize: localizeReducer,
  mainNavIsVisible,
  pageOverlayIsVisible,
})

export default reducers
